// constants
import SliderDraggableEvent from '../../../components/slider-draggable/slider-draggable-event';

export default class GalleryAboutTeamDetail {

	static selector = 'gallery-about-team-detail';

	// class variables

	el = {};

	states = {
		total: 0
	};

	// constructor

	constructor(container) {
		this.el = {
			container,

			ctaPrev: container.querySelector(`.${this.constructor.selector}__control-left`),
			ctaNext: container.querySelector(`.${this.constructor.selector}__control-right`),
			index: container.querySelector(`.${this.constructor.selector}__control-index`),

			items: container.querySelectorAll(`.${this.constructor.selector}__item`)
		};

		if (this.el.items.length > 1) {
			this.initialize();
		}
	}

	// initialize

	initialize() {
		this.states.total = this.el.items.length;
		this.#addEventListeners();
		this.adjustSliderIndex(0);
	}

	// add and remove listeners

	#addEventListeners = () => {
		this.el.ctaPrev.addEventListener('click', this.#onCtaPrevClick);
		this.el.ctaNext.addEventListener('click', this.#onCtaNextClick);

		this.el.container.addEventListener(SliderDraggableEvent.SEEKING, this.#onSliderSeeking);
	}

	#removeEventListeners = () => {
		this.el.ctaPrev.removeEventListener('click', this.#onCtaPrevClick);
		this.el.ctaNext.removeEventListener('click', this.#onCtaNextClick);

		this.el.container.removeEventListener(SliderDraggableEvent.SEEKING, this.#onSliderSeeking);
	}

	// listener methods

	#onCtaPrevClick = () => {
		this.el.container.dispatchEvent(new CustomEvent(SliderDraggableEvent.PREV));
	}

	#onCtaNextClick = () => {
		this.el.container.dispatchEvent(new CustomEvent(SliderDraggableEvent.NEXT));
	}

	#onSliderSeeking = (e) => {
		this.adjustSliderIndex(e.detail.index);
	}

	//

	adjustSliderIndex(index) {
		this.el.index.innerHTML = index >= 10 ? index + 1 : `0${index + 1}`;

		// set active / inactive button states

		if (index <= 0) {
			this.el.ctaPrev.classList.add('is-disabled');
		} else {
			this.el.ctaPrev.classList.remove('is-disabled');
		}

		if (index >= this.el.items.length - 1) {
			this.el.ctaNext.classList.add('is-disabled');
		} else {
			this.el.ctaNext.classList.remove('is-disabled');
		}
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
